module.exports = __webpack_public_path__ + "img/new-logo-ministerio.e9225ce2.svg";